<template>
  <div class="server-status">
    <div class="status-title">服务器状态</div>
    <div class="status-list">
      <div class="status-item">
        <span>CPU占用：</span><span>{{ status.cpu }}%</span>
      </div>
      <div class="status-item">
        <span>内存占用：</span><span>{{ status.memory }}%</span>
      </div>
      <div class="status-item">
        <span>硬盘占用：</span><span>{{ status.disk }}%</span>
      </div>
      <div class="status-item">
        <span>数据库连接：</span><span :style="{color: status.dbConnected ? '#67c23a' : '#f56c6c'}">{{ status.dbConnected ? '正常' : '异常' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeServerStatus',
  props: {
    status: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.server-status {
  background: var(--color-bg-3);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.08);
  padding: 24px;
}
.status-title {
  font-size: 16px;
  font-weight: bold;
  color: var(--color-text-1);
  margin-bottom: 16px;
}
.status-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.status-item {
  font-size: 14px;
  color: #666;
  display: flex;
  justify-content: space-between;
}
</style>